import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ForumMember } from "src/app/shared/interfaces/forum";
import { SharedModule } from "src/app/shared/shared.module";

@Component({
  selector: "forum-mentions-list",
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: "./forum-mentions-list.component.html",
  styleUrls: ["./forum-mentions-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForumMentionsListComponent {
  @Input() members: ForumMember[] = [];
  @Input() activeIndex = 0;

  @Output() selectMember = new EventEmitter<ForumMember>();

  getDisplayName(member: ForumMember): string {
    return (
      [member.first_name, member.last_name].filter(Boolean).join(" ") || "-"
    );
  }

  trackByMember(index: number, member: ForumMember): string {
    return member.id;
  }
}
